import {Component, Inject, Input, OnInit, Optional} from '@angular/core';
import { TradeType } from '../../../models/common/trading-common.model';
import { TradingService } from '../../../services/common/trading-service.service';

@Component({
    selector: 'disclaimers-component',
    templateUrl: './disclaimers.component.html',
    styleUrls: ['./disclaimers.component.css']
})
export class DisclaimersComponent implements OnInit {
    @Input() tradeType: TradeType;

    showDisclaimers: boolean = false;
    isEquity: boolean = false;
    isExtendedHours: boolean = false;
    isMutualFund: boolean = false;
    isOption: boolean = false;
    isRetail: boolean = false;
    activeTheme: string;

    constructor(private tradingService: TradingService,@Optional() @Inject('AppSettings') appSettings: any) {
      if (appSettings && appSettings.platform && appSettings.platform === 'retail') {
        this.isRetail = true;
      }
    }

    ngOnInit() {
        this.isEquity = this.tradeType === TradeType.EQUITY;
        this.isExtendedHours = this.tradeType === TradeType.EXTENDED_HOURS;
        this.isMutualFund = this.tradeType === TradeType.MUTUAL_FUND || this.tradeType === TradeType.PLAN_529FUND;
        this.isOption = this.tradeType === TradeType.OPTION;
        this.activeTheme = this.tradingService.getActiveThemeFromCurrentContainer();
        this.showDisclaimers = this.isRetail;
    }

    toggleDisclaimers(): void {
        this.showDisclaimers = !this.showDisclaimers;
    }

    isShowingDisclaimers(): boolean {
        return this.showDisclaimers;
    }
}
